module.exports = __webpack_public_path__ + "static/series_cb-6d547d7e1bbb40b9c418549e53c66a4b.png";